import React from 'react'

const PieChart = () => {
  return (
    <div>
      
    </div>
  )
}

export default PieChart
